<template>
  <div id="app">
    <router-view class="main"></router-view>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style lang="scss" rel="stylesheet/scss">
  @import "assets/style/index.scss";

  #app {
    height: 100%;
  }

  .main {
    background: #f5f5f5;
  }

  @font-face {
    font-family: 'iconfont';  /* project id 1284250 */
    src: url('//at.alicdn.com/t/font_1284250_n0nhbfyjlja.eot');
    src: url('//at.alicdn.com/t/font_1284250_n0nhbfyjlja.eot?#iefix') format('embedded-opentype'),
    url('//at.alicdn.com/t/font_1284250_n0nhbfyjlja.woff2') format('woff2'),
    url('//at.alicdn.com/t/font_1284250_n0nhbfyjlja.woff') format('woff'),
    url('//at.alicdn.com/t/font_1284250_n0nhbfyjlja.ttf') format('truetype'),
    url('//at.alicdn.com/t/font_1284250_n0nhbfyjlja.svg#iconfont') format('svg');
  }

  .iconfont {
    font-family: "iconfont" !important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .icon-serviceanshidaohuo:before {
    content: "\e600";
  }

  .icon-serviceshandianfahuo:before {
    content: "\e601";
  }

  .icon-serviceshangmenanzhuang:before {
    content: "\e602";
  }

  .icon-servicesonghuoruhu:before {
    content: "\e603";
  }

  .icon-serviceyanchangbaoxiu:before {
    content: "\e604";
  }

  .icon-servicesonghuoruhu1:before {
    content: "\e607";
  }

  .icon-serviceanshidaohuo1:before {
    content: "\e605";
  }

  .icon-serviceshandianfahuo1:before {
    content: "\e606";
  }

  .icon-serviceshangmenanzhuang1:before {
    content: "\e608";
  }

  .icon-typecar109:before {
    content: "\e630";
  }

  .icon-jingpin:before {
    content: "\e60e";
  }

  .icon-remai:before {
    content: "\e709";
  }

</style>



// WEBPACK FOOTER //
// src/App.vue